import axios from 'axios';
import { environment } from '@environments/environment';
import { paramsSerializer } from '@services/utils/OverviewServiceUtils';
import { PagesConfig } from '@utils/pageConfig/PagesConfigContext';
import {FilterKeys, Option} from '@utils/pageConfig/Types';
import { byFilterKey } from '@utils/pageConfig/Predicates/SelectedFiltersPredicates';
import { DEFAULT_CURRENCY_DROPDOWN_COUNTRIES, getCurrencyCode } from '@utils/currencyUtils/CurrencyUtils';
import { formatCustomWeeksPeriodPayload, getEndOfRangedPeriod, getPeriodMetaFactory } from '@utils/PeriodUtils';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { BaseTimePeriod } from '@services/FiltersTypes';
import { CurrencyExchangeRatePerCountry } from '@services/Types';

export const getCurrencyExchangeRate = async (
  period: BaseTimePeriod,
  pagesConfig: PagesConfig,
  periodType: Periodicity,
  defaultCurrency: Option
): Promise<CurrencyExchangeRatePerCountry[]> => {
  let countryIds = pagesConfig.clientCountries
    .map((country) => {
      if ('value' in country) {
        return country.value.toUpperCase();
      } else {
        return country.id.toUpperCase();
      }
    })
    .join('&country=');

  DEFAULT_CURRENCY_DROPDOWN_COUNTRIES.forEach((country) => {
    if (!countryIds.includes(country.countryCode)) {
      countryIds = countryIds.concat(`&country=${country.countryCode.toUpperCase()}`);
    }
  });

  const periodTypeMonthlyOrWeekly = [Periodicity.CustomWeeks, Periodicity.Weekly].includes(periodType)
    ? Periodicity.Weekly
    : Periodicity.Monthly;
  let periodMetaForExplore;

  if (Periodicity.CustomWeeks !== periodType) {
    const periodFormated = getEndOfRangedPeriod(period.value, periodTypeMonthlyOrWeekly);
    periodMetaForExplore = getPeriodMetaFactory(
      periodFormated,
      periodFormated,
      periodTypeMonthlyOrWeekly,
      undefined,
      true,
    );
  }
  const currencyFilter = pagesConfig.appliedFilters[pagesConfig.pageType].selectedFilters.find(
    byFilterKey(FilterKeys.CURRENCY),
  );

  const { data } = await axios.get<CurrencyExchangeRatePerCountry[]>(constructCurrencyUrl(), {
    params: {
      country: countryIds,
      period:
        Periodicity.CustomWeeks === periodType
          ? formatCustomWeeksPeriodPayload(period.value).split(' - ')[1]
          : periodMetaForExplore?.currentPeriod.toUpperCase(),
      selectedCurrency: currencyFilter ? getCurrencyCode(currencyFilter) : defaultCurrency.value.split(' ')[0],
      periodType: periodTypeMonthlyOrWeekly.toUpperCase(),
    },
    paramsSerializer: paramsSerializer,
  });
  return data;
};

const constructCurrencyUrl = () => {
  return `${environment.baseUrl}/v2/currency/exchange-rates`;
};
